import { render, staticRenderFns } from "./index.vue?vue&type=template&id=4195523c&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4195523c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4195523c')) {
      api.createRecord('4195523c', component.options)
    } else {
      api.reload('4195523c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=4195523c&scoped=true&", function () {
      api.rerender('4195523c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistics/tag-print-log/modules/table-list/index.vue"
export default component.exports